import { Fragment as _Fragment, jsx as _jsx } from 'react/jsx-runtime.js';
import { isGDPRModalActiveSelector } from './stepModalSlice.js';
import { useAppSelector } from '../../hooks.js';
import { stepModalFormConfigs } from './stepModalFormConfigs.js';
import { activeViewSelector, activeWrapperSelector, WRAPPER_TYPES, isFullscreenSelector, } from '../../core/wrapperContext/wrapperContextSlice.js';
import { FadeTransition } from '../../../components/common/transitions/index.js';
import { FullscreenTwoStepContent } from '../../../components/FullscreenTwoStepContent/index.js';
import { DialogWrapper } from '../Modal/DialogWrapper/index.js';
import { showRegistrationSuccessfulModalSelector } from '../../../views/Registration/registrationSlice.js';
import CVUploadModal from '../../features/registrationSuccess/RegistrationSuccessModal/index.js';
export const StepModalComponent = ({ hideModal, }) => {
    const activeView = useAppSelector(activeViewSelector);
    const activeWrapper = useAppSelector(activeWrapperSelector);
    const isFullscreen = useAppSelector(isFullscreenSelector);
    const isGDPRModalActive = useAppSelector(isGDPRModalActiveSelector);
    const showRegistrationSuccessfulModal = useAppSelector(showRegistrationSuccessfulModalSelector);
    const stepModalForms = stepModalFormConfigs();
    const activeFormConfig = stepModalForms.find(({ type }) => type === activeView);
    const ViewComponent = activeFormConfig?.component;
    const isStepModalVisible = activeWrapper === WRAPPER_TYPES.STEP_MODAL && !isGDPRModalActive;
    if (!isStepModalVisible || !ViewComponent || !activeView) {
        return _jsx(_Fragment, {});
    }
    if (showRegistrationSuccessfulModal) {
        return _jsx(CVUploadModal, {});
    }
    return (_jsx(DialogWrapper, { hideModal: hideModal, modalType: activeView, isModalVisible: true, fullscreenModal: isFullscreen, children: isFullscreen ? (_jsx(FullscreenTwoStepContent, {})) : (_jsx(FadeTransition, { transitionKey: activeView, sx: {
                display: 'flex',
                maxWidth: '100%',
            }, children: _jsx(ViewComponent, {}) })) }));
};
//# sourceMappingURL=StepModalComponent.js.map